var _circle, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubmittedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 105,
    viewBox: "0 0 105 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 52.5,
    cy: 52.5,
    r: 50.5,
    fill: "url(#paint0_linear_850_4974)",
    stroke: "white",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 52L47 64",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2344 64.2324L71.2344 40.2324",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_850_4974",
    x1: 52.5,
    y1: 0,
    x2: 52.5,
    y2: 105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#19C73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#189D35"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmittedIcon);
export default __webpack_public_path__ + "static/media/submittedIcon.4277facd0de1525fc3e9878c153d2a24.svg";
export { ForwardRef as ReactComponent };